import clsx from 'clsx';
import { useState } from 'react';

import styles from './RevampTable.module.scss';

export interface RevampTableLogoProps {
  logo?: string | null;
  fallbackLabel: string | number;
  className?: string;
  alt?: string;
}

export const RevampTableLogo = ({
  logo,
  fallbackLabel,
  className,
  alt = '',
}: RevampTableLogoProps) => {
  const [hasError, setHasError] = useState(false);
  const fallbackText = String(fallbackLabel).trim().charAt(0).toUpperCase();

  if (!logo || hasError) {
    return (
      <span
        className={clsx(styles.logoFallback, className)}
        data-testid="revamp-table-logo-fallback"
      >
        {fallbackText}
      </span>
    );
  }

  return (
    <img
      src={logo}
      alt={alt}
      className={className}
      data-testid="revamp-table-logo"
      onError={() => setHasError(true)}
    />
  );
};
